module.exports = __webpack_public_path__ + "static/media/Koala.4ddfb3a8.png";